'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', '\n\n  align-items: center;\n  color: ', ';\n  display: flex;\n  font-weight: 500;\n  justify-content: space-between;\n  padding: 15px 15px 15px 5px;\n  width: 100%;\n'], ['\n  ', '\n  ', '\n\n  align-items: center;\n  color: ', ';\n  display: flex;\n  font-weight: 500;\n  justify-content: space-between;\n  padding: 15px 15px 15px 5px;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-left: 15px;\n  max-height: 0;\n  overflow: hidden;\n  transition: 500ms max-height;\n\n  li {\n    font-size: ', ';\n\n    &:not(:first-child) {\n      margin-top: 5px;\n    }\n\n    &:last-child {\n      margin-bottom: 15px;\n    }\n  }\n\n  &.open {\n    max-height: 50vh;\n  }\n'], ['\n  margin-left: 15px;\n  max-height: 0;\n  overflow: hidden;\n  transition: 500ms max-height;\n\n  li {\n    font-size: ', ';\n\n    &:not(:first-child) {\n      margin-top: 5px;\n    }\n\n    &:last-child {\n      margin-bottom: 15px;\n    }\n  }\n\n  &.open {\n    max-height: 50vh;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-top: 1px solid ', ';\n  display: ', ';\n\n  @media(min-width: ', ') {\n    display: none;\n  }\n'], ['\n  border-top: 1px solid ', ';\n  display: ', ';\n\n  @media(min-width: ', ') {\n    display: none;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _ButtonReset = require('../../../../../mixins/ButtonReset');

var _ButtonReset2 = _interopRequireDefault(_ButtonReset);

var _Caret = require('../../../../../mixins/Caret');

var _Caret2 = _interopRequireDefault(_Caret);

var _config = require('../../../../../config.js');

var _Link = require('../../Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var caretSettings = {
  size: '4px'
};

var AccordionToggle = _styledComponents2.default.button(_templateObject, (0, _ButtonReset2.default)(), (0, _Caret2.default)(caretSettings), _config.colors.red);

AccordionToggle.displayName = 'AccordionToggle';

var AccordionContent = _styledComponents2.default.ul(_templateObject2, (0, _polished.rem)('14px', _config.typography.baseFontSize));

AccordionContent.displayName = 'AccordionContent';

var Wrapper = _styledComponents2.default.div(_templateObject3, _config.colors.gray, function (props) {
  return props.collapse ? 'block' : 'none';
}, _config.breakpoints.m);

Wrapper.displayName = 'Wrapper';

var LinkAccordion = function (_React$Component) {
  _inherits(LinkAccordion, _React$Component);

  function LinkAccordion(props) {
    _classCallCheck(this, LinkAccordion);

    var _this = _possibleConstructorReturn(this, (LinkAccordion.__proto__ || Object.getPrototypeOf(LinkAccordion)).call(this, props));

    _this.state = {
      isOpen: false
    };

    _this.toggleOpenState = _this.toggleOpenState.bind(_this);
    return _this;
  }

  _createClass(LinkAccordion, [{
    key: 'toggleOpenState',
    value: function toggleOpenState() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          overviewUrl = _props.overviewUrl,
          links = _props.links;
      var isOpen = this.state.isOpen;

      var renderedLinks = links.map(function (link) {
        return _react2.default.createElement(
          'li',
          {
            key: link.Text
          },
          _react2.default.createElement(
            _Link2.default,
            { href: link.Href },
            link.Text
          )
        );
      });

      return _react2.default.createElement(
        Wrapper,
        {
          collapse: this.props.collapse
        },
        _react2.default.createElement(
          AccordionToggle,
          {
            className: isOpen ? 'open' : '',
            'aria-expanded': isOpen,
            onClick: this.toggleOpenState
          },
          title
        ),
        _react2.default.createElement(
          AccordionContent,
          {
            className: isOpen ? 'open' : ''
          },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _Link2.default,
              { href: overviewUrl },
              'Overview'
            )
          ),
          renderedLinks
        )
      );
    }
  }]);

  return LinkAccordion;
}(_react2.default.Component);

LinkAccordion.propTypes = {
  title: _propTypes2.default.string.isRequired,
  overviewUrl: _propTypes2.default.string.isRequired,
  links: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  collapse: _propTypes2.default.bool
};

LinkAccordion.defaultProps = {
  collapse: true
};

LinkAccordion.displayName = 'LinkAccordion';

exports.default = LinkAccordion;
LinkAccordion.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'toggleOpenState',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'displayName': 'LinkAccordion',
  'props': {
    'collapse': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'overviewUrl': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'links': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'object'
        }
      },
      'required': true,
      'description': ''
    }
  }
};